const useSortItems = () => {

    const sortItemsTopOfTheList = (list, items) => {
        let newList = []
        list.forEach((u) => {
            if (items.some(m => m.id === u.id)) {
                newList.unshift(u)
            } else {
                newList.push(u)
            }
        })
        return newList
    }

    const sortOneItemTopOfTheList = (list, item) => {
        let newList = []
        list.forEach((u) => {
            if (u.id === item?.id) {
                newList.unshift(u)
            } else {
                newList.push(u)
            }
        })
        return newList
    }

    const pushItemsInArray = (items, keyName) => {
        if (items.length > 0) {
            let itemsSelected = []
            items.forEach((item) => {
                itemsSelected.push({[keyName]: item.id})
            })
            return itemsSelected
        }
    }
    const pushItemsByNameInArray = (items, keyName) => {
        if (items.length > 0) {
            let itemsSelected = []
            items.forEach((item) => {
                itemsSelected.push({[keyName]: item.name})
            })
            return itemsSelected
        }
    }
    const returnRemovedItems = (allItemsSelected, initialsItems, keyName) => {
        let items = initialsItems.filter(x => !allItemsSelected.includes(x))
        return pushItemsInArray(items, keyName)
    }

    const returnAddedItems = (allItemsSelected, initialsItems, keyName) => {
        let items = allItemsSelected.filter(x => !initialsItems.includes(x))
        if (keyName.toLowerCase().includes("name")) {
            return pushItemsByNameInArray(items, keyName)
        } else {
            return pushItemsInArray(items, keyName)
        }
    }

    const getItemsByFilter = (list, key, filter) => {
        return list.filter(item => item[key]?.id === filter)
    }


    return {
        returnRemovedItems,
        returnAddedItems,
        pushItemsInArray,
        pushItemsByNameInArray,
        sortItemsTopOfTheList,
        sortOneItemTopOfTheList,
        getItemsByFilter,
    }
}

export default useSortItems